export const ManagementSymbol = Symbol('management');
